import { FormControl, InputLabel, Select } from '@mui/material'
import React from 'react'

const LabeledDropDown = ({ className, label, options, value, onChange, inputProps, disabled, style, extraSelectProps = {} }) => {
  return (
    <FormControl
      size="small"
      variant="outlined"
      className={`tp-dropdown-form ${className}`}
      style={style || {}}
    >
      <InputLabel id={label + 'Label'}>{label}</InputLabel>
      <Select
        size='small'
        fullWidth
        className="width-100"
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
              maxWidth: 400,
            },
          },
        }}
        defaultValue={""}
        disabled={disabled || false}
        labelId={label + 'Label'}
        id={label}
        value={value}
        label={label}
        onChange={onChange}
        inputProps={inputProps || {}}
        {...extraSelectProps}
      >
        {options}
      </Select>
    </FormControl>
  )
}

export default LabeledDropDown